/* eslint-disable import/order */
import Request from '@hotmart/request';
import { action } from 'mobx';

import Store from './BroadcastStore';
import { UiService } from 'modules/ui';
import { MembershipStore } from 'modules/membership';
import { DeepSearchStore, DeepSearchService } from 'modules/userManager';
import { UserStore } from 'modules/user';

import './BroadcastApi';

const DEFAULT_ROWS = 10;

class BroadcastService {
  @action
  setData(data = {}) {
    Object.assign(Store, { ...data });
  }

  @action
  async getBroadcasts() {
    try {
      const parameters = {
        areaId: MembershipStore.id,
        page: Store.listBroadcast.pagination.page,
        rows: Store.listBroadcast.pagination.perPage
      };

      const response = await Request('get.broadcasts', parameters);

      this.setData({
        listBroadcast: {
          content: response.content,
          pagination: {
            ...Store.listBroadcast.pagination,
            numberOfElements: response.numberOfElements,
            page: response.page,
            totalElements: response.totalElements
          }
        }
      });
    } catch (e) {
      UiService.handleError(e);
    }
  }

  @action
  async getBroadcastUsers(messageId, user, page, rows = DEFAULT_ROWS) {
    try {
      const parameters = {
        messageId,
        page,
        rows,
        user
      };

      const users = await Request('get.broadcast.users', parameters);

      return { content: users };
    } catch (e) {
      UiService.handleError(e);
    }
  }

  @action
  async getBroadcastFilters(messageId) {
    try {
      return await Request('get.broadcast.filters', { messageId });
    } catch (e) {
      UiService.handleError(e);
    }
  }

  updateFilters = (filters) => {
    const sentToAllUsers = !filters.length && Store.newBroadcast.sentToAllUsers;

    this.setData({
      newBroadcast: {
        ...Store.newBroadcast,
        filters,
        sentToAllUsers
      }
    });
  };

  trimFilters = (filters) => {
    return filters.map((filter) => {
      if (filter.query) {
        filter.query = filter.query.trim().replace(/\s{2,}/g, ' ');
      }
      return filter;
    });
  };

  formatFilters(query) {
    const { filters } = DeepSearchStore.searchParameters;

    const formatedFilters = this.trimFilters(filters);

    this.updateFilters(filters);

    formatedFilters.push({
      _type: 'simple',
      query
    });

    return formatedFilters;
  }

  shouldFetchUsers = () => {
    const { filters } = DeepSearchStore.searchParameters;
    const { sentToAllUsers } = Store.newBroadcast;

    return filters.length || sentToAllUsers;
  };

  setUsersLength = (usersLength) => {
    this.setData({
      newBroadcast: {
        ...Store.newBroadcast,
        usersLength
      }
    });
  };

  formatUsers = (users) => {
    return users.map((user) => ({
      name: user.userName,
      email: user.userEmail,
      pictureThumbId: user.userPictureThumbId
    }));
  };

  @action
  async searchUsersByFilter(query, page) {
    const users = { content: [] };

    if (!this.shouldFetchUsers()) {
      this.updateFilters([]);
      this.setUsersLength(0);
      return users;
    } else {
      try {
        const size = 10;
        const filters = this.formatFilters(query);
        const response = await Request('post.search.users.by.filter', {
          filters,
          page,
          size
        });

        if (!query) {
          this.setUsersLength(response.totalElements);
        }

        users.content = this.formatUsers(response.content);
      } catch (e) {
        UiService.handleError(e);
      }
      return users;
    }
  }

  @action
  async saveBroadcast() {
    try {
      const { filters, ...newBroadcast } = Store.newBroadcast;

      const parameters = {
        ...newBroadcast,
        areaId: MembershipStore.id,
        filters: encodeURI(JSON.stringify(filters)),
        senderId: UserStore.hash
      };

      await Request('post.save.broadcast', parameters);

      Store.resetNewBroadcast();
      DeepSearchService.clearFiltersByCallback();

      UiService.setAlertSuccess('broadcast_sent_with_success');
    } catch (e) {
      UiService.handleError(e);
      throw e;
    }
  }

  @action
  setDeepSearchValid() {
    Store.isDeepSearchValid = true;
  }

  @action
  setDeepSearchInvalid() {
    Store.isDeepSearchValid = false;
  }
}

export default new BroadcastService();
